import React, { Component } from "react";

import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import moment from "moment";
import PurchaseOrderProductsTable from "./PurchaseOrderProductsTable";
import { Button, Dropdown, Menu, message } from "antd";
import { PrinterOutlined, MailOutlined } from "@ant-design/icons";
import instance from "../../../store/actions/instance";

class PurchaseOrderInvoice extends Component {
  state = { sendingEmailLoading: false };

  printIframe = async (type) => {
    const { t, selectedOrder } = this.props;
    this.setState({ invoicesLoading: true });
    try {
      const invoice = await instance.get(
        `purchase/invoice/${type}/${selectedOrder.id}`
      );
      const iframe = document.frames
        ? document.frames["printingIframe"]
        : document.getElementById("printingIframe");
      iframe.srcdoc = invoice.data;
    } catch (e) {
      console.error(e);
      message.error(t("SomethingWentWrong"));
      this.setState({ invoicesLoading: false });
      return false;
    }
  };
  sendEmail = async () => {
    const { t, selectedOrder } = this.props;
    this.setState({ sendingEmailLoading: true });
    try {
      const invoice = await instance.post("send_purchase_order_email", {
        Id: selectedOrder.id,
      });
      message.success(t("Sent Email successfully"));
      selectedOrder.email_sent = true;
    } catch (e) {
      message.error(t("SomethingWentWrong"));
    }
    this.setState({ sendingEmailLoading: false });
  };
  render() {
    const { t, selectedOrder, products, isViewOnly } = this.props;
    const { sendingEmailLoading } = this.state;
    const printMenu = (
      <Menu>
        <Menu.Item key="1" onClick={() => this.printIframe("order")}>
          {t("Purchase Order")}
        </Menu.Item>
        <Menu.Item key="2" onClick={() => this.printIframe("receiving_note")}>
          {t("Receiving Note")}
        </Menu.Item>
      </Menu>
    );
    return (
      <div
        className="jumbotron bg-white p-0 mt-4"
        style={{ paddingTop: 20, minWidth: 320 }}
      >
        <iframe
          id="printingIframe"
          style={{ display: "none" }}
          title="Receipt"
          onLoad={() => {
            const iframe = document.frames
              ? document.frames["printingIframe"]
              : document.getElementById("printingIframe");
            if (!this.state.invoicesLoading || !iframe.srcdoc) return;

            const iframeWindow = iframe.contentWindow || iframe;
            iframe.focus();
            iframeWindow.print();
            this.setState({ invoicesLoading: false });
          }}
        />
        {!["Pending Approval", "Cancelled", "Rejected", "Draft"].includes(
          selectedOrder.status
        ) && (
          <div className="my-3 " style={{ display: "flex", gap: 12 }}>
            <Dropdown overlay={printMenu}>
              <Button icon={<PrinterOutlined style={{ fontSize: 19 }} />}>
                {t("Print")}
              </Button>
            </Dropdown>
            {selectedOrder.supplier__email?.trim() &&
              !selectedOrder.email_sent && (
                <Button
                  loading={sendingEmailLoading}
                  icon={<MailOutlined style={{ fontSize: 19 }} />}
                  onClick={this.sendEmail}
                >
                  {t("Send Email")}
                </Button>
              )}
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              display: "flex",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Tracking Code")}:
            </span>
            <span>{selectedOrder.tracking_id}</span>
          </div>
          {selectedOrder.delivery_date && (
            <div
              style={{
                display: "flex",
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  minWidth: 150,
                }}
              >
                {t("Delivery Date")}:
              </span>
              <span>
                {moment(selectedOrder.delivery_date).format(
                  "MMM Do YYYY - h:mm a"
                )}
              </span>
            </div>
          )}
          <div
            style={{
              display: "flex",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Placed")}:
            </span>
            <span>
              {moment(selectedOrder.created).format("MMM Do YYYY - h:mm a")} -{" "}
              {t("by ")}
              {selectedOrder.created_by__username}
            </span>
          </div>
          {selectedOrder.approved_date && (
            <div
              style={{
                display: "flex",
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  minWidth: 150,
                }}
              >
                {t("Approved Date")}:
              </span>
              <span>
                {selectedOrder.approved_date
                  ? `${moment(selectedOrder.approved_date).format(
                      "MMM Do YYYY - h:mm a"
                    )} - ${t("by")} ${selectedOrder.cancelled_by__username}`
                  : "-"}
              </span>
            </div>
          )}
          {selectedOrder.received_date && (
            <div
              style={{
                display: "flex",
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  minWidth: 150,
                }}
              >
                {t("Received Date")}:
              </span>
              <span>
                {selectedOrder.received_date
                  ? `${moment(selectedOrder.received_date).format(
                      "MMM Do YYYY - h:mm a"
                    )} - ${t("by")} ${selectedOrder.received_by__username}`
                  : "-"}
              </span>
            </div>
          )}
          {selectedOrder.cancelled_date && (
            <div
              style={{
                display: "flex",
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  minWidth: 150,
                }}
              >
                {t("Cancelled Date")}:
              </span>
              <span>
                {selectedOrder.cancelled_date
                  ? `${moment(selectedOrder.cancelled_date).format(
                      "MMM Do YYYY - h:mm a"
                    )} - ${t("by")} ${selectedOrder.cancelled_by__username}`
                  : "-"}
              </span>
            </div>
          )}
          <div style={{ display: "flex" }}>
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Branch")}:
            </span>

            <span>{selectedOrder.branch__name}</span>
          </div>
          <div style={{ display: "flex" }}>
            <span
              style={{
                fontWeight: "bold",
                minWidth: 150,
              }}
            >
              {t("Supplier")}:
            </span>

            <span>{selectedOrder.supplier__name}</span>
          </div>
        </div>
        <PurchaseOrderProductsTable
          setEditMode={this.props.setEditMode}
          isReceiving={this.props.isReceiving}
          setProducts={this.props.setProducts}
          editMode={this.props.editMode}
          products={products}
          isViewOnly={isViewOnly}
          selectedOrder={selectedOrder}
        />

        {selectedOrder.notes && (
          <>
            <h6>Note:</h6>
            <p>{selectedOrder.notes}</p>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    settings: state.auth.settings,
    config: state.config,
    is_staff: state.auth.is_staff,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(PurchaseOrderInvoice));
